import { QueryClient } from '@tanstack/react-query'

import { throttleAwareQueryDefaults } from '@mangovoice/api-client'

/**
 * A window focus only refetches queries that are already stale, so this default
 * collapses the burst of requests a returning softphone user would otherwise
 * send. A per-query `staleTime` still replaces this value.
 */
export const defaultStaleTime = 60_000

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Do not retry 429s, and honour Retry-After when a retry does fire.
      ...throttleAwareQueryDefaults,
      staleTime: defaultStaleTime,
    },
  },
})
